import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Icon, IconName} from '../../../../../libs/shared/ui/src/components/icon/icon';
import {flexCenter} from '../../../../../libs/shared/ui/src/styles/mixins';

interface FilterLabel {
  icon?: IconName;
  color?: string;
  children: ReactNode;
}

const FilterLabelWrapper = styled.div`
  ${flexCenter};
`;

const StyledIcon = styled(Icon)`
  margin-right: 8px;
`;

export const FilterLabel: FC<FilterLabel> = ({icon, color, children}) => (
  <FilterLabelWrapper>
    {icon ? <StyledIcon name={icon} color={color} /> : null}
    {children}
  </FilterLabelWrapper>
);
